module.exports = __webpack_public_path__ + "653f886bbd84acc04dfd3407f0608063.svg";